import React, { useEffect } from "react";
import Intro from "../components/SalonPage/Intro" 

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Intro />
    </>
  );
};

export default Home;